import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Service from './pages/Service/Service'
import Products from './pages/Our Products/Our_Products';
import About from './pages/About Us/About_Us';
import OpratingAreas from './pages/Oprating Areas/Oprating_Areas';
import OurExpertise from './pages/Our Expertise/Our_Expertise';
import Industry from './pages/Industry Focus/Industry_Focus'
import WhyChooseUs from './pages/Why Choose Us/WhyChooseUs'
import ContactUs from './pages/Contact Us/ContactUs';
import Privacy from './pages/Privacy and Cookie Policy/Privacy';
import TermsOfService from './pages/Terms of Service/TermsOfService';
import AdvancedSearch from './pages/Advanced Search/AdvancedSearch';
import Articles from './pages/Articles/Articles';
import LatestNews from './pages/Latest News/LatestNews';
import Career from './pages/Career/Career';
import FloatingButton from './components/FloatingButton/FloatingButton';
import Cookies from './components/Cookies/Cookies';



function App() {

  const handleClick=()=>{
    window.scrollTo(0,0);
  }
  return (
    <BrowserRouter>
    <Navbar/>
      <Routes>
        <Route path='/our-products' element={<Products/>}/>
        <Route path='/' element={<Home/>}/>
        <Route path='/services' element={<Service/>}/>
        <Route path='/about-us' element={<About/>}/>
        <Route path='/oprating-areas' element={<OpratingAreas/>}/>
        <Route path='/our-expertise' element={<OurExpertise/>}/>
        <Route path='/industry-focus' element={<Industry/>}/>
        <Route path='/why-choose-us' element={<WhyChooseUs/>}/>
        <Route path='/contact-us' element={<ContactUs/>}/>
        <Route path='/privacy-and-cookie-policy' element={<Privacy/>}/>
        <Route path='/terms-of-service' element={<TermsOfService/>}/>
        <Route path='/advanced-search' element={<AdvancedSearch/>}/>
        <Route path='/articles' element={<Articles/>}/>
        <Route path='/latest-news' element={<LatestNews/>}/>
        <Route path='/career' element={<Career/>}/>
      </Routes>
      <FloatingButton onClick={handleClick}/>
      <Footer/>
      <Cookies/>
    </BrowserRouter>
  );
}

export default App;
